import React from 'react';
import { Select } from 'antd';
import {DownOutlined} from "@ant-design/icons";
import { t } from '../i18n';
import { useFilterLayoutStyles } from '../utils/languageUtils';

interface OptionType {
    label: string;
    value: string | number | boolean;
}

interface FilterItemProps {
    label: string;
    options: string[] | OptionType[];
    value?: string[];
    onChange?: (value: string[]) => void;
    className?: string;
    spanClassName?: string;
    disabled?: boolean;
    required?: boolean;
    forceHorizontal?: boolean;
}

/**
 * 多选选择器
 * @description 基于SingleSelect改造的多选组件，支持多选模式
 */
const MultiSelect: React.FC<FilterItemProps> = ({label, options, value, onChange, className, spanClassName, disabled = false, required = false, forceHorizontal}) => {
    const { containerClassName, labelClassName, inputContainerClassName } = useFilterLayoutStyles(spanClassName, className, forceHorizontal);
    
    // 判断options是简单字符串数组还是对象数组
    const isObjectOptions = options.length > 0 && typeof options[0] !== 'string';

    const handleChange = (selectedValue: string[] | undefined) => {
        if (onChange) onChange(selectedValue || []);
    };
    
    return (
        <div className={containerClassName}>
            <span className={labelClassName}>
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </span>
            <div className={inputContainerClassName}>
                <Select 
                    mode="multiple"
                    value={value || []}
                    onChange={handleChange} 
                    className="w-full"
                    placeholder={t('components.input.all')}
                    allowClear
                    showSearch
                    suffixIcon={<DownOutlined />}
                    disabled={disabled}
                    size="middle"
                    filterOption={(input, option) => {
                        if (isObjectOptions) {
                            // 对于对象数组，基于 label 进行搜索
                            const optionLabel: any = String(option?.children || '');
                            return optionLabel.toLowerCase().includes(input.toLowerCase());
                        } else {
                            // 对于字符串数组，基于 value 进行搜索
                            return String(option?.value || '').toLowerCase().includes(input.toLowerCase());
                        }
                    }}
                >
                    {isObjectOptions ? 
                        // 对象数组选项
                        (options as OptionType[]).map((option) => (
                            <Select.Option key={option.value.toString()} value={option.value.toString()}>
                                {option.label}
                            </Select.Option>
                        ))
                        : 
                        // 字符串数组选项
                        (options as string[]).map((option) => (
                            <Select.Option key={option} value={option}>{option}</Select.Option>
                        ))
                    }
                </Select>
            </div>
        </div>
    );
};

export default MultiSelect;
